// extracted by mini-css-extract-plugin
export default {"modal":"WalletFormRequest_modal__CyJA9"};